import { motion } from 'framer-motion'
import SectionWrapper from '../layout/SectionWrapper'

const adventures = [
  { emoji: '🚢', title: 'Croisière', description: 'Une escapade romantique sur les eaux' },
  { emoji: '🎭', title: 'Spectacle Comédie', description: 'Rire ensemble, toujours' },
  { emoji: '🎳', title: 'Bowling', description: 'Compétition amicale' },
  { emoji: '🎬', title: 'Titanic', description: 'Notre film au grand écran' }
]

const simpleMoments = [
  { emoji: '🌅', title: 'Vieux-Port', description: 'Couchers de soleil magiques' },
  { emoji: '⛰️', title: 'Mont-Royal', description: 'Nos balades préférées' }
]

export default function EteSection() {
  return (
    <SectionWrapper
      id="ete"
      gradient="from-dark-primary to-dark-secondary"
    >
      {/* Header */}
      <motion.div className="text-center mb-16">
        <motion.span
          className="tag-pill mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span>☀️</span>
          <span>Été 2025</span>
        </motion.span>

        <motion.h2
          className="text-4xl md:text-6xl font-serif font-bold gradient-text mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          Notre Été Ensemble
        </motion.h2>

        <motion.p
          className="text-lg text-light-pink-100/70"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
        >
          Des aventures et des moments simples qui nous ont rapprochés
        </motion.p>
      </motion.div>

      {/* Adventures Grid */}
      <motion.div
        className="mb-16"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        <h3 className="text-xl font-semibold text-primary-pink mb-6 text-center">
          🎉 Nos Aventures
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {adventures.map((item, index) => (
            <motion.div
              key={item.title}
              className="glass-card text-center"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{
                y: -5,
                boxShadow: '0 15px 30px rgba(232, 81, 178, 0.2)'
              }}
            >
              <motion.span
                className="text-5xl block mb-3"
                whileHover={{ scale: 1.2, rotate: [0, -10, 10, 0] }}
                transition={{ duration: 0.3 }}
              >
                {item.emoji}
              </motion.span>
              <h4 className="font-bold text-white mb-1">{item.title}</h4>
              <p className="text-sm text-light-pink-100/60">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>

      {/* Simple Moments */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        <h3 className="text-xl font-semibold text-primary-pink mb-6 text-center">
          ✨ Moments Simples, Souvenirs Précieux
        </h3>
        <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          {simpleMoments.map((item, index) => (
            <motion.div
              key={item.title}
              className="flex items-center gap-6 glass-card"
              initial={{ opacity: 0, x: index === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              whileHover={{ scale: 1.02 }}
            >
              <span className="text-6xl">{item.emoji}</span>
              <div>
                <h4 className="text-xl font-bold text-white mb-1">{item.title}</h4>
                <p className="text-light-pink-100/70">{item.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>

      {/* Quote */}
      <motion.blockquote
        className="text-center mt-16 max-w-2xl mx-auto"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <p className="text-xl md:text-2xl text-light-pink-100/80 italic font-serif leading-relaxed">
          "Les moments simples sont les plus beaux
          <br />
          Avec toi, tout devient nouveau"
        </p>
        <footer className="mt-4 text-primary-pink text-sm">
          — Verse 3
        </footer>
      </motion.blockquote>
    </SectionWrapper>
  )
}
